import { createFeatureSelector, createSelector } from '@ngrx/store'
import {
  CUSTOMER_PAYMENT_METHODS_FEATURE_KEY,
  State,
  customerPaymentMethodsAdapter,
} from './customer-payment-methods.reducer'

// Lookup the 'CustomerPaymentMethods' feature state managed by NgRx
export const getCustomerPaymentMethodsState = createFeatureSelector<State>(CUSTOMER_PAYMENT_METHODS_FEATURE_KEY)

const { selectAll, selectEntities } = customerPaymentMethodsAdapter.getSelectors()

export const getCustomerPaymentMethodsLoaded = createSelector(
  getCustomerPaymentMethodsState,
  (state: State) => state.loaded,
)

export const getAllCustomerPaymentMethods = createSelector(getCustomerPaymentMethodsState, (state: State) =>
  selectAll(state),
)

export const getCustomerPaymentMethodsEntities = createSelector(getCustomerPaymentMethodsState, (state: State) =>
  selectEntities(state),
)

export const getSelectedId = createSelector(getCustomerPaymentMethodsState, (state: State) => state.selectedId)

export const getSelected = createSelector(getCustomerPaymentMethodsEntities, getSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const getHasCards = (includeDigitalWallets: boolean) =>
  createSelector(getAllCustomerPaymentMethods, (paymentMethods) =>
    includeDigitalWallets
      ? paymentMethods.length > 0
      : paymentMethods.some((paymentMethod) => !paymentMethod.card.wallet_type),
  )
